export default "__VITE_ASSET__CoMAvtw4__"